import PageModel from '_c/page-model';

export default {
    components: {
        PageModel
    },
    data() {
        return {
            tableLoading: false,
            tableList: [],
            page: {
                page: 1,
                size: 10,
            },
            // 总记录
            total: 0
        }
    },
    methods: {
        refreshGetTableData(){
          this.page.page = 1;
          this.getTableData();
        },
        getTableData() {
            throw new Error('未定义getTableData方法');
        },
        handlePageChange(pageNo, pageSize) {
            this.page.page = pageNo;
            this.page.size = pageSize;

            this.getTableData();
         }
    }

}
